import { Contract, FormInput } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import { useTranslation } from 'react-i18next';
import { IContractInputBaseProps } from '../base/ContractInputBase';
import { IDistributionType, TEMPLATE_TYPE } from 'services/templates/types';

interface IContractInputDistributionSectionProps
  extends Omit<IContractInputBaseProps, 'name'> {
    distributionType: IDistributionType
  }

const ContractInputDistributionSection = ({
  id,
  distributionType,
  ...props
}: IContractInputDistributionSectionProps) => {
  const { itemNameById, displayMode } = useFormikContractHelpers();

  const { t } = useTranslation();
  return (
    <Contract.Input.Base
      {...props}
      id={id}
      classNames={['contract-section-input']}
      name={`${itemNameById(id)}.content`}
      placeholder={t('input.placeholder.distribution', {type: t(`enum.TEMPLATE_TYPE.${TEMPLATE_TYPE[distributionType]}`)})}>
    </Contract.Input.Base>
  );
};

export default ContractInputDistributionSection;
